import React from 'react';
import PropTypes from 'prop-types';
import UiComponent from '../UiComponent';

export default class TextArea extends UiComponent {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  componentDidMount() {
    window.fixTextArea();
  }


  changeValue(value) {
    this.props.field.value = value;
    if (this.props.relatedTo && this.props.relatedTo.length > 0) {
      this.props.onChange([
          this.props.relatedTo,
          this.props.field.name,
        ],
        this.props.field
      );
    } else {
      this.props.onChange(this.props.field.name, this.props.field);
    }
  }

  render() {
    const containerClass = `form-group ${this.props.className}`;
    return (
      <div className={containerClass}>
        {this.getLabel()}
        <textarea
          autoComplete="off"
          type={this.getFieldProp('type')}
          className={`form-control${this.props.extraClass !== undefined ? ' ' + this.props.extraClass : ''}`}
          placeholder={this.getFieldProp('placeholder')}
          onChange={e => this.changeValue(e.target.value)}
          value={this.getFieldProp('value')}
          disabled={this.props.disabled}
        />
        {this.getErrors()}
      </div>
    );
  }
}

TextArea.propTypes = {
  relatedTo: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.object,
  field: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/TextArea/index.js